
import Educare from "../../../assets/duotone/Educare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EducareIcon({ className, dataTestid = "EducareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Educare data-testid={dataTestid} className={classes} {...rest} />
  );
}
